import React, { useState, useRef, useEffect } from 'react';
import styles from './accordionStatus.module.css';
import SolidChevron from '../../icons/SolidChevron';
import { formatMoney } from '../../../helpers/format';

const AccordionCommision = ({ children, category, index, categoryName, t }) => {
  const [selected, setSelected] = useState(categoryName);
  const [height, setHeight] = useState(null);
  const accordionRef = useRef(null);

  const toggle = () => {
    setSelected(selected === null ? index : null);
  };

  useEffect(() => {
    const updateComponentHeight = () => {
      if (accordionRef.current) {
        const height = accordionRef.current.clientHeight;
        setHeight(height);
      }
    };
    updateComponentHeight();
    window.addEventListener('resize', updateComponentHeight);
    return () => {
      window.removeEventListener('resize', updateComponentHeight);
    };
  }, []);

  return (
    <div className={`${styles.accordionContainer}`}>
      <div className={styles.wrapperAccordion}>
        <div className={styles.accordion}>
          <div className={styles.item}>
            <div className={`${styles.accordionContainer}`}>
              <div className='my-auto row mt-2 px-2' onClick={toggle} style={{ cursor: 'pointer' }}>
                <div className={`${styles.points} py-3 font-tiny fw-semibold text-secondary`}>
                  <span>{`${formatMoney(
                    category.commissionPercentage,
                    { decimals: 0, currencySymbol: '' },
                    true,
                  )} % `}</span>
                </div>

                <div className='col py-3 pr-0'>
                  <div className={`d-flex align-items-center text-secondary bold`}>
                    {t(`commissionTypes.${category.reservationType}`)}
                  </div>
                  <div
                    className={
                      selected === index ? `${styles.content} ${styles.show}` : `${styles.content}`
                    }
                  >
                    {children}
                  </div>
                </div>

                <div className='col-auto py-3 mr-2' style={{ overflow: 'hidden' }}>
                  <div
                    style={{
                      transition: 'transform 0.4s ease-in-out',
                      transform: `rotate(${selected === index ? -180 : 0}deg)`,
                    }}
                  >
                    <SolidChevron color='var(--color-primary)' size='18px' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionCommision;
